<template>
  <div :class="$style.container">
    <MdmSetupForm
      v-if="isAddingANewToken"
      :itemType="certSetupType"
      :token="token"
      @back-button="handleBackButton"
      @file-uploaded="handleFileUpload"
      @setup-completed="handleSetupCompleted"
    />
    <GettingStartedPanel
      buttonLabel="add token"
      :itemType="vppItemType"
      :visible="shouldRenderGettingStarted"
      @ctaButtonClick="handleGettingStartedCta()"
    />
    <div
      v-if="shouldRenderMainPanel"
    >
      <FlatActionButton
        :action="handleAddNewToken"
        :class="$style.addNewBtn"
      >
        add new
      </FlatActionButton>
      <VppConfigurationTable
        :columns="columns"
        :itemType="vppItemType"
        :tableData="getTableData"
        tableTitle="VPP Configuration"
        @renewVppToken="handleRenewToken"
      />
    </div>
  </div>
</template>

<script>
import {
  ItemTypeConsts, MdmFormsTypes, StoreModuleMap, UnsavedChangesModalConsts,
} from 'client/util/Constants';
import { mapActions, mapState } from 'vuex';
import FlatActionButton from 'components/Buttons/FlatActionButton.vue';
import GettingStartedPanel from 'components/GettingStartedPanel/GettingStartedPanel.vue';
import MdmCertificateStatus from 'client/MDM/components/MdmCertificateStatus.vue';
import MdmSetupForm from 'client/MDM/MdmSetupForm.vue';
import ModalEventBus from 'components/Modal/ModalEventBus';
import VppConfigurationTable from 'client/MDM/VppConfigurationTable.vue';

const { mdmVpp } = ItemTypeConsts;
const { headerText, bodyText } = UnsavedChangesModalConsts;
const { vppToken, vppRenew } = MdmFormsTypes;

const vppModule = StoreModuleMap[ItemTypeConsts.mdmVpp];

export default {
  name: 'VppSettingsMainPanel',

  components: {
    FlatActionButton,
    GettingStartedPanel,
    MdmSetupForm,
    VppConfigurationTable,
  },

  props: {
    openTokenForm: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    columns: [
      {
        dataField: 'organizationName',
        name: 'Organization',
      },
      {
        dataField: 'locationName',
        name: 'Location',
      },
      {
        dataField: 'appleId',
        name: 'Apple ID',
      },
      {
        bodyComponent: MdmCertificateStatus,
        bodyComponentProps: {
          expiresOnDate: 'sTokenExpiry',
        },
        dataField: 'sTokenExpiry',
        name: 'Status',
      },
    ],
    certSetupType: vppToken,
    fileUploaded: false,
    isAddingANewToken: false,
    vppItemType: mdmVpp,
    token: {},
  }),

  computed: {
    ...mapState(vppModule, [
      'locations',
      'totalCount',
    ]),

    getTableData() {
      return this.locations.map(location => ({
        organizationName: location.organizationName,
        locationName: location.locationName,
        appleId: location.appleId,
        sTokenExpiry: location.sTokenExpiry,
        id: location.id,
      }));
    },

    shouldRenderGettingStarted() {
      return this.totalCount === 0 && !this.isAddingANewToken;
    },

    shouldRenderMainPanel() {
      return this.totalCount > 0 && !this.isAddingANewToken;
    },
  },

  mounted() {
    this.handleMounted();
  },

  created() {
    this.handleCreated();
  },

  methods: {
    ...mapActions(vppModule, [
      'fetchLocations',
    ]),

    handleAddNewToken() {
      this.certSetupType = vppToken;
      this.isAddingANewToken = true;
    },

    async handleBackButton() {
      if (!this.fileUploaded) {
        this.isAddingANewToken = false;
      } else {
        this.showConfirmationModal();
      }
      await this.fetchLocations();
    },

    handleCreated() {
      if (this.openTokenForm) this.handleAddNewToken();
    },

    handleFileUpload(value) {
      this.fileUploaded = value;
    },

    handleGettingStartedCta() {
      this.certSetupType = vppToken;
      this.isAddingANewToken = true;
    },

    async handleMounted() {
      await this.fetchLocations();
    },

    handleRenewToken(tokenId) {
      this.certSetupType = vppRenew;
      this.token = this.locations.find(e => e.id === tokenId);
      this.isAddingANewToken = true;
    },

    handleSetupCompleted() {
      this.fileUploaded = false;
      this.isAddingANewToken = false;
    },

    showConfirmationModal() {
      ModalEventBus.open({
        component: 'ConfirmationModal',
        componentProps: {
          bodyText,
          handleContinue: () => {
            this.fileUploaded = false;
            this.isAddingANewToken = false;
            ModalEventBus.close();
          },
          headerText,
        },
        preventCloseOnOverlayClick: true,
      });
    },
  },
};
</script>

<style module>
.container {
  margin: 40px 20px 0;
}

.container .addNewBtn {
  margin-bottom: 10px;
}
</style>
